import { Controller } from "stimulus"

export default class extends Controller {

    static targets = ["from", "to"]

    translate() {
        
        console.log(`ill translate soon!`)
        const fromField = this.fromTarget
        const toField = this.toTarget

        var url = "https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=ar&dt=t&q=" + encodeURI(fromField.value);
        fetch(url)
            .then(function (response) {
                return response.json();
            })
            .then(function (myJson) {
                toField.value = myJson[0][0][0];
                
            });
        
    }

    translateDynamic(e) {

        const from = e.target.dataset.from
        const to = e.target.dataset.to
        const elmFrom = document.querySelectorAll(`[data-target='translation.${from}']`)[0]
        const elmTo = document.querySelectorAll(`[data-target='translation.${to}']`)[0]
        var url = "https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=ar&dt=t&q=" + encodeURI(elmFrom.value);
        fetch(url)
            .then(function (response) {
                return response.json();
            })
            .then(function (myJson) {
              console.log("myJson[0][0][0]:", myJson[0][0][0]);
                elmTo.value = myJson[0][0][0];
                
            });
        
    }


    

}